// TODO: location.hash to open the corresponding course 
const TrainingCoursesFilter = {
    theForm: null,
    courseDom: null,
    data: null,
    fields: [ 'product', 'deployment', 'role', ], // 'delivery', 
    messageDom: null,
    resultCount: 0,
    init: function(theForm) {
        this.theForm = theForm;
        if (this.theForm) {
            this.fields.forEach(this.fieldsForEachHandler, this);
            this.courseDom = document.getElementById('coursesContainer');
            // this.resetSelectWidth();
            this.initializeClearFilter();
            if (!this.courseDom) {
                console.warn('Course DOM is undetected!');
            }
            this.messageDom = document.getElementById('filterErrorMessage');
        }

        // Read course data from global scope.
        const intervalHandler = function() {
            console.debug(`» intervalId: ${intervalId}`, this);
            if (globalCourseData) {
                this.data = globalCourseData;
                clearInterval(intervalId);
            }
        }
        const intervalId = setInterval(intervalHandler.bind(this), 250);

        // if (location.hash) {
        //     var courseKey = location.hash.substring(1).split('/')[0]
        //     IllumioTrainingCertification.expandCourse(courseKey,1)
        // }
    },
    /**
     * Looping through the fields array and set onchange event.
     * @param {*} field
     */
    fieldsForEachHandler: function(field) {
        if (this.theForm[field]) {
            this.theForm[field].onchange = this.selectOnChangeHandler.bind(this);
        }
    },
    resetSelectWidth: function() {
        var maxWidth = 0;
        for (var i=0;i<this.fields.length;i++) {
            var element = this.theForm[this.fields[i]];
            if (element) {
                var currentWidth = element.offsetWidth;
                currentWidth += 16;
                element.style.width = currentWidth + 'px';
            }
            if (element.offsetWidth>maxWidth) {
                maxWidth = element.offsetWidth;
            }
        }
        for (var i=0;i<this.fields.length;i++) {
            element.style.width = maxWidth + 'px';
        }
    },
    initializeClearFilter: function() {
        var element = document.getElementById('clearFilter');
        if (element) {
            element.onclick = this.clearFilterOnClickHandler.bind(this);
        }
    },
    clearFilterOnClickHandler: function(event) {
        event.preventDefault();
        // var fieldsForEachHandler = function(field, index) {
        //     this.theForm[field].disabled = (index===0) ? false : true;
        // }
        this.theForm.reset();
        // this.fields.forEach(fieldsForEachHandler, this);
        this.processFilter();
        // this.updateLocationHash();
    },
    selectOnChangeHandler: function(event) {
        console.debug('Element changed');
        console.debug(event.currentTarget);
        console.debug(this);
        this.processFilter();
        this.updateFilterWidgets(event.currentTarget);
        // this.updateLocationHash();
    },
    processFilter: function() {
        if (this.data) {
            this.messageDom.classList.add('hidden');

            this.resultCount = 0;
            for (var i=0;i<this.courseDom.childElementCount;i++) {
                this.toggleCourseDom(this.courseDom.children[i]);
            }
            console.debug('processFilter(): this.resultCount: ' + this.resultCount);
        } else {
            console.warn('Filter action is not proceeding due to missing course data.');
        }
        // setTimeout(IllumioSupportTemplate.resetContentHeight, 100);
    },
    updateFilterWidgets: function(currentFormElement) {
        console.debug('» currentFormElement');
        console.debug(currentFormElement);
        if (this.resultCount<=0) {
            this.messageDom.classList.remove('hidden');
        // } else {
        //     var nextFormElement = null; 
        //     if (currentFormElement.nextElementSibling && currentFormElement.nextElementSibling.tagName==='SELECT') {
        //         nextFormElement = currentFormElement.nextElementSibling;
        //     }
        //     if (nextFormElement) {
        //         console.debug('» nextFormElement');
        //         console.debug(nextFormElement);
        //         console.debug('»»» this.resultCount: ' + this.resultCount);
        //         nextFormElement.disabled = false;
        //         for (var i=0;i<this.theForm.elements.length;i++) {
        //             if (this.theForm.elements[i].name===nextFormElement.name) {
        //                 this.theForm.elements[i].disabled = false;
        //                 if (i>0) {
        //                     this.theForm.elements[i-1].disabled = false;
        //                 }
        //             } else {
        //                 this.theForm.elements[i].disabled = true;
        //             }
        //         }
        //     }
        }
    },
    toggleCourseDom: function(element) {
        if (element.id && element.id.match(/^_course_/)) {
            var course_code = element.id.replace('_course_', '');

            var keyData = this.getKeyData(this.data[course_code]);
            console.debug(keyData);

            // 'product', 'deployment', 'role'
            var compareMatrix = {};
            for (var i=0;i<this.fields.length;i++) {
                var field = this.fields[i];
                if (this.theForm[field] && 
                        this.theForm[field].selectedIndex>0 &&
                        keyData['keywords'].indexOf(this.theForm[field].value)>=0) {
                    compareMatrix[field] = true;
                } else if (this.theForm[field] && this.theForm[field].selectedIndex==0) {
                    compareMatrix[field] = true;
                } else if (!this.theForm[field]) {
                    compareMatrix[field] = true;
                } else {
                    compareMatrix[field] = false;
                }
            }

            console.debug('» compareMatrix: ' + JSON.stringify(compareMatrix));

            // Suppress result for certain scenarios.
            if ((this.theForm['product'].value==='Product:Illumio CloudSecure' && this.theForm['deployment'].value==='Deployment:On Premise') ||
                    (this.theForm['product'].value==='Product:Illumio CloudSecure' && this.theForm['deployment'].value==='Deployment:SaaS' && this.theForm['role'].value==='Role:Misc. Courses') ||
                    (this.theForm['product'].value==='Product:Illumio Endpoint') && this.theForm['role'].value==='Role:Misc. Courses') {
                for (var i=0;i<this.fields.length;i++) {
                    compareMatrix[this.fields[i]] = false;
                }
            }

            console.debug('» compareMatrix (final): ' + JSON.stringify(compareMatrix));

            if ((!this.theForm['product'] || this.theForm['product'].selectedIndex==0) &&
                    (!this.theForm['deployment'] || this.theForm['deployment'].selectedIndex==0) &&
                    (!this.theForm['role'] || this.theForm['role'].selectedIndex==0)) {
                element.style.display = 'block';
                this.resultCount++;
                console.debug('» Show Element due to non-selected fields for all');
            } else if (compareMatrix['product']==true &&
                    compareMatrix['deployment']==true &&
                    compareMatrix['role']==true) {
                element.style.display = 'block';
                this.resultCount++;
                console.debug('» Show Element');
            } else {
                element.style.display = 'none';
                console.debug('» Hide Element');
            }
        }
    },
    getKeyData: function(record) {
        let dataHashKeys = Object.keys(record);
        let deliveryFormat = 'self_paced';
        for (let i=dataHashKeys.length-1;i>=0;i--) {
            if (dataHashKeys[i]!='languages') {
                deliveryFormat = dataHashKeys[i];
                break;
            }
        }

        return {
            delivery: deliveryFormat,
            keywords: record[deliveryFormat]['keywords'],
        }
    },
}

export default TrainingCoursesFilter;
